import axios from "axios";
import { ApiConnection } from "../config/env";

const API_TIMEOUT = 5 * 60 * 1000; // 5 minutes
let lastUserActivityTimestamp = Date.now();
let timeoutRef = null;

const dispatchToggleSessionAlert = () => {
  import("../redux/store").then(({ default: store }) => {
    import("../redux/authSlice").then(({ ToggleSessionAlert }) => {
      store.dispatch(ToggleSessionAlert(true));
    });
  });
};

// Function to reset session timeout based on user activity
const resetSessionTimeout = () => {
  let loggedInUser = JSON.parse(sessionStorage.getItem("userLoggedDetails"));
  if (!loggedInUser) return;

  if (timeoutRef) clearTimeout(timeoutRef);

  timeoutRef = setTimeout(() => {
    const timeSinceLastActivity = Date.now() - lastUserActivityTimestamp;
    if (loggedInUser?.id && timeSinceLastActivity >= API_TIMEOUT) {
      dispatchToggleSessionAlert();
    }
  }, API_TIMEOUT);
};

// Function to track user activity
const trackUserActivity = () => {
  lastUserActivityTimestamp = Date.now();
  resetSessionTimeout();
};

// Attach event listeners for user activity
const startTrackingUserActivity = () => {
  document.addEventListener("mousemove", trackUserActivity);
  document.addEventListener("keydown", trackUserActivity);
  document.addEventListener("click", trackUserActivity);
  resetSessionTimeout(); // Start the timeout when tracking begins
};

// Remove event listeners when session ends
const stopTrackingUserActivity = () => {
  document.removeEventListener("mousemove", trackUserActivity);
  document.removeEventListener("keydown", trackUserActivity);
  document.removeEventListener("click", trackUserActivity);
  clearTimeout(timeoutRef);
};

// Start tracking user activity when the session begins
startTrackingUserActivity();

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: ApiConnection.BACKEND_URL,
});

// Add these variables at the top of your axiosInstance.js
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

// // Create a function to retry the original request with the new token
// const retryRequest = async (error) => {
 
//   const originalRequest = error.config;

//   try {
//     // Retrieve the new token from sessionStorage
//     const newToken = sessionStorage.getItem("userLoggedToken");

//     // Clone the original request configuration
//     const retryConfig = {
//       ...originalRequest,
//       headers: {
//         ...originalRequest.headers,
//         Authorization: `Bearer ${newToken}`,
//       },
//     };

//     // Retry the original request using axiosInstanceForJson
//     return await axiosInstance(retryConfig);
//   } catch (retryError) {
//     console.error("Retry request failed:", retryError);
//     return Promise.reject(retryError);
//   }
// };

axiosInstance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("userLoggedToken");
    if (token) {
      config.headers["Authorization"] = "Bearer " + JSON.parse(token);
    }
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => {
    console.error("Error in request", error);
    return Promise.reject(error);
  }
);




// Update the response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = `Bearer ${token}`;
            return axiosInstance(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const refreshToken =await  JSON.parse(sessionStorage.getItem("refreshToken"));
        const accessToken =await  JSON.parse(
          sessionStorage.getItem("userLoggedToken")
        );
        const store = await import("../redux/store");
        const authSlice = await import("../redux/authSlice");
        await store.default.dispatch(
          authSlice.renewToken([refreshToken], accessToken)
        );
        console.log(
          "SUcceesssssssssssXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX???????????????///////////////////////",
        );
        const newToken = JSON.parse(sessionStorage.getItem("userLoggedToken"));
        processQueue(null, newToken);
        return axiosInstance(originalRequest);
      } catch (renewError) {
        processQueue(renewError, null);
        return Promise.reject(renewError);
      } finally {
        isRefreshing = false;
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
